/**
 * Design tokens for the step-based Risikoanalyse form.
 *
 * Brand colors come from the user's design system; the four pillar
 * colors mirror the original PDF graphic.
 */
export const BRAND = {
  fontPrimary: "'Barlow', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  fontAccent: "'Playfair Display', Georgia, 'Times New Roman', serif",
  // Brand
  ink: "#2d142b",
  purple: "#4d2051",
  gold: "#f7a823",
  white: "#ffffff",
  // Pillar tile colors (welcome graphic + sidebar accents)
  pillarOrange: "#E66A2C",
  pillarBlue: "#3D8BD9",
  pillarGreen: "#2E7D4F",
  pillarBlack: "#1F1B24",
  // Misc neutrals
  border: "#E3E0E7",
  borderDashed: "#ECE7F0",
  muted: "#7c7480",
  bg: "#fafafa",
  cardBg: "#ffffff",
};

/**
 * „Refined Classic"-Tokens für die Kontaktanlage (Firma/Privat). Werte 1:1 aus
 * den Designvorlagen (courte/designs/): Aubergine als gezielter Akzent, ruhige
 * Karten mit Haarlinie + weichem Schatten statt Rahmen, Hanken Grotesk (UI) +
 * Instrument Serif (edle Akzente). Bewusst getrennt von BRAND, damit der Umbau
 * der Anlage nichts anderes im Produkt mitfärbt.
 */
export const REFINED = {
  // Aubergine-Scale
  aub50: "#f8eef5",
  aub100: "#f0dcea",
  aub200: "#e2bcd7",
  aub: "#7d2169",
  aub700: "#6e1c5c",
  aubDeep: "#3a0c31",
  mag: "#b21f93",
  // Neutral & Status
  ink: "#241522",
  ink2: "#6b5a66",
  ink3: "#a294a0",
  line: "#ddd3dc",
  fieldBg: "#f8f4f8",
  white: "#ffffff",
  ok: "#2f7d5b",
  okBg: "#e9f4ee",
  err: "#c23b3b",
  errBg: "#fbecec",
  // Gold/Amber — Akzentfarbe für Hinweise/Badges.
  gold: "#f0a020",
  goldBg: "#fdf3d6",
  goldInk: "#8a6d00",
  goldLine: "#f3dcae",
  // Typo
  fontUI: "'Hanken Grotesk', 'Segoe UI', Tahoma, sans-serif",
  /**
   * Typo-Skala (px) — 6 benannte Stufen statt Ad-hoc-Größen. Eyebrow/Labels →
   * xxs, Meta/Chips → xs, Sekundärtext → sm, Fließtext/Werte → md,
   * Kartentitel → lg, Detail-Betreff → xl.
   */
  fs: { xxs: 11, xs: 12, sm: 13, md: 15, lg: 18, xl: 24 },
  // Effekte
  cardShadow: "0 6px 22px rgba(58,12,49,0.13), 0 2px 6px rgba(58,12,49,0.07)",
  btnShadow: "0 4px 14px -4px rgba(125,33,105,0.55), 0 2px 6px rgba(125,33,105,0.30)",
  focusRing: "0 0 0 3px rgba(125,33,105,0.15)",
  errRing: "0 0 0 3px rgba(194,59,59,0.13)",
};
